
//header setting moved to app.js
/*window.axios.defaults.headers.common = {
    //'X-CSRF-TOKEN': window.Laravel.csrfToken,
    //'X-Requested-With': 'XMLHttpRequest',
    //'userId':window.Laravel.user_id,
};*/
import KrAuth from './components/auth/auth.js';
import Vue from 'vue';
import {globalMixins} from './mixins/global.js';

let auth = new KrAuth()
axios.defaults.headers['Content-Type'] = 'application/vnd.api+json';
if(auth.isLoggedIn()){
  axios.defaults.baseURL = auth.credential().API_URL;
}
axios.defaults.timeout = 60000;
// Add a request interceptor
axios.interceptors.request.use(function (config) {
  if(auth.getAuthHeader()){
    config.headers['Authorization'] = auth.getAuthHeader();
  }
  if(_.get(config,'_internal.hasLoadingBar',true)){
     $('#loading').removeClass('hide').addClass('show');
  }
  return config;
  }, function (error) {
    // Do something with request error
    setTimeout(function(){   $('#loading').removeClass('show').addClass('hide'); }, 50);
    
    return Promise.reject(error);
  });

// Add a response interceptor
axios.interceptors.response.use(function (response) {
     setTimeout(function(){  $('#loading').removeClass('show').addClass('hide'); }, 50);
     let unixServerTime = moment.utc(response.headers['date'],'ddd, DD MMM YYYY HH:mm:ss [GMT]',true).unix();
     //console.log(response.headers['date'])
     //console.log('---converted unix---')
     //console.log(unixServerTime)
     //console.log('---end---')
     globalMixins.methods.setMomentOffset(unixServerTime);
     return response;
  }, function (error) {
    console.log(error)
     setTimeout(function(){  $('#loading').removeClass('show').addClass('hide'); }, 50);
    if (!error.response) {
      Vue.notify({
        group: 'form',
        type:'error',
        title: 'Error',
        text:'Something went wrong. Please try again later'
      });
      // network error 
      throw new axios.Cancel('Network Error');
    }
    else if(error.response.status==401&&_.get(error,'response.data.status_code')!=200){
      Vue.notify({
        group: 'form',
        type:'error',
        title: 'Error',
        text:'Session Expired'
      });
      Events.fire('logout',{from:'AXIOS_401'});
      throw new axios.Cancel('Session Expired');
    }
    else if(error.response.status==404&&_.get(error,'response.data.status_code')!=200){
    //else if(error.response.status==401&&_.get(error,'response.data.message')=='EXP'){
      if(auth.isLoggedIn()){
          Vue.notify({
            group: 'form',
            type:'error',
            title: 'Error',
            text:'Not Found Error'
          });
          //Events.fire('logout',{'redirect':{name:'auth.login'}});
         //window.location.reload();
          throw new axios.Cancel('Not Found Error');
      }
    }
    else if(error.response.status==403){
      window.app.$router.push({name: 'errors.403'})
    }
    else if(error.code=='ECONNABORTED'){
        Events.fire('axios_timed_out'); 
        throw new axios.Cancel('API Connection Timed out');
    }
    // Do something with response error
    return Promise.reject(error);
});
